// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"146":"0ed2be88","278":"904ee197","485":"560f09b6","538":"18968422","644":"0bb76148","838":"cfaac94a"}[chunkId] + ".js";
};